var offsetX = 0;
var offsetY = -2.0;
var width = 50;
var height = 70;
var rotate = 0;
var marginX = 2.0;
var marginY = 2.0;
var titleFontSize = 5.6;
var titleWidth = width - marginX * 2;
var titleHeight = 7.4;

var sheetHeight = 6.0;

var contentWidth = width - marginX * 3;
var contentHeight = 4.3;
var fontSize = 3;

var qrCodeHeight = height - marginY * 28;
var qrCodeWidth = qrCodeHeight;
//文本打印数据
export const ReturnTextPrintData = {
  InitDrawingBoardParam: {
    width: width,
    height: height,
    rotate: rotate,
    path: "ZT001.ttf",
    verticalShift: 0,
    HorizontalShift: 0,
  },

  elements: [
    {
      type: "text",
      json: {
        x: marginX + offsetX,
        y: marginY * 2 + offsetY,
        height: titleHeight,
        width: titleWidth,
        value: "退回供应商标签",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: titleFontSize,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [true, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 6.5 + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "手机品牌：苹果",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: fontSize,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 6.5 + sheetHeight + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "型号：iphone 13ProMax",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: fontSize,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    // {
    //   type: "text",
    //   json: {
    //     x: marginX * 1.5 + offsetX,
    //     y: marginY * 6.5 + sheetHeight * 2 + offsetY,
    //     height: contentHeight,
    //     width: contentWidth,
    //     value: "颜色：银色",
    //     fontFamily: "宋体",
    //     rotate: 0,
    //     fontSize: fontSize,
    //     textAlignHorizonral: 0,
    //     textAlignVertical: 1,
    //     letterSpacing: 0.0,
    //     lineSpacing: 1.0,
    //     lineMode: 6,
    //     fontStyle: [false, false, false, false],
    //   },
    // },
    // {
    //   type: "text",
    //   json: {
    //     x: marginX * 1.5 + offsetX,
    //     y: marginY * 6.5 + sheetHeight * 3 + offsetY,
    //     height: contentHeight,
    //     width: contentWidth,
    //     value: "内存：256G",
    //     fontFamily: "宋体",
    //     rotate: 0,
    //     fontSize: fontSize,
    //     textAlignHorizonral: 0,
    //     textAlignVertical: 1,
    //     letterSpacing: 0.0,
    //     lineSpacing: 1.0,
    //     lineMode: 6,
    //     fontStyle: [false, false, false, false],
    //   },
    // },
    // {
    //   type: "text",
    //   json: {
    //     x: marginX * 1.5 + offsetX,
    //     y: marginY * 6.5 + sheetHeight * 4 + offsetY,
    //     height: contentHeight,
    //     width: contentWidth,
    //     value: "序列号：SMFP366Q1HW",
    //     fontFamily: "宋体",
    //     rotate: 0,
    //     fontSize: fontSize,
    //     textAlignHorizonral: 0,
    //     textAlignVertical: 1,
    //     letterSpacing: 0.0,
    //     lineSpacing: 1.0,
    //     lineMode: 6,
    //     fontStyle: [false, false, false, false],
    //   },
    // },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 6.5 + sheetHeight * 2 + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "IMEI：356479390626709",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: fontSize,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 6.5 + sheetHeight * 3 + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "原因：好",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: 5,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    // {
    //   type: "text",
    //   json: {
    //     x: marginX * 1.5 + offsetX,
    //     y: marginY * 6.5 + sheetHeight * 6 + offsetY,
    //     height: contentHeight,
    //     width: contentWidth,
    //     value: "IMEI2：356479390755639",
    //     fontFamily: "宋体",
    //     rotate: 0,
    //     fontSize: fontSize,
    //     textAlignHorizonral: 0,
    //     textAlignVertical: 1,
    //     letterSpacing: 0.0,
    //     lineSpacing: 1.0,
    //     lineMode: 6,
    //     fontStyle: [false, false, false, false],
    //   },
    // },
    {
      type: "qrCode",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 6.5 + sheetHeight * 4 + offsetY,
        height: qrCodeHeight,
        width: qrCodeWidth,
        value: "http://localhost:8080/#/staticQueryPage/000000001",
        codeType: 31,
        rotate: 0,
        fontSize: fontSize,
        textHeight: fontSize,
        textPosition: 0,
      },
    },
    {
      type: "text",
      json: {
          x: marginX * 3 + qrCodeWidth + offsetX,
          y: marginY * 6.5 + sheetHeight * 4 + offsetY,
          height: qrCodeHeight,
          width: contentWidth - qrCodeWidth -marginX,
          value: "请扫码查看详情",
          fontFamily: "宋体",
          rotate: 0,
          fontSize: fontSize,
          textAlignHorizonral: 0,
          textAlignVertical: 1,
          letterSpacing: 0.0,
          lineSpacing: 1.0,
          lineMode: 6,
          fontStyle: [true, false, false, false],
      }
  }

  ],
};



// WEBPACK FOOTER //
// ./src/utils/printData/ReturnText.js